<div class="main-container" *ngIf="course">
  <div class="container-area flex-row-container">
    <div class="simulation-poster-container">
      <div class="poster-image" [style.backgroundImage]="'url(' + (course.postermedia?.path || '/assets/wonda/background2_ld.jpg') + ')'"></div>
    </div>
    <div class="flex-column-container container-area-right">
      <div class="assessment-title-container flex-row-container programs-h5">
        <div class="assessment-title text-truncate">{{ course?.title }}</div>
        <span class="assessment-title-reports">sessions</span>
      </div>
      <div class="chart-container">
        <mat-card id="traffic-chart-container">
          <mat-card-content *loading="trafficDataStatus">
            <google-chart *ngIf="trafficChart" [data]="trafficChart"></google-chart>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
  <div class="session-list">
    <session-list [course]="course" [programsMode]="true" [date_from]="dateFrom" [date_to]="dateTo" [search]="activeUserSearch" (onExplore)="displayLogs($event)" (onExport)="exportLogs($event)"></session-list>
  </div>
</div>
